import { HTMLInputTypeAttribute, useEffect, useState } from "react";
import { useController, UseControllerProps } from "react-hook-form";

type InputProps = UseControllerProps<any> & {
    label?: string;
    className?: string;
    type?: HTMLInputTypeAttribute;
};

function Input(props: InputProps) {
    let { label = '', className = '', type, rules } = props;
    const { field, fieldState } = useController(props);
    let [isUp, setisUp] = useState(!!field.value);
    useEffect(() => {
        setisUp(!!field.value)
    }, [field.value])
    let [passShow, setpassShow] = useState(false);
    return <div className={`pt-3 pb-2 ${className} `}>
        <label className="relative h-[52px] block bg-form-bg  rounded-lg overflow-hidden ">
            <span className={`absolute left-3  text-grey ${isUp ? " text-ms leading-7" : " text-xs leading-[52px]"} `}>{label}{rules?.required ? <i className=" text-red">*</i> : null}</span>
            <input
                className="absolute fuck-autofill appearance-none bottom-0 w-full h-[34px] outline-none text-black bg-form-bg  bg-opacity-0 px-3 focus-visible:border-b focus-visible:border-blue"
                type={passShow ? "text" : type}
                onFocus={() => { setisUp(true); }}
                {...field}
                onBlur={(e) => {
                    setisUp(!!e.target.value)
                    field.onBlur()
                }}
            />
            {type === "password" ?
                <span className=" absolute right-0 h-full pr-4 text-base leading-[52px] text-black cursor-pointer"
                    onClick={() => {
                        setpassShow(!passShow)
                    }}
                >
                    <span className=" underline">
                        {passShow ? "hidden" : "show"}
                    </span>
                </span>
                : null}
        </label>
        {fieldState.error ? <p className=" text-ms leading-3 mt-2 text-red pl-3">{fieldState.error?.message}</p> : null}
    </div>
}

export default (Input);